// © Microsoft Corporation. All rights reserved.

/**
 * Use this interface to register experiences for page reveal
 */
export interface PageRevealRegistrationInterface {

    /**
     * identifier
     */
    readonly experienceType: string;

    /**
     * page reveal info for the experience
     */
    readonly pageRevealInfo: PageRevealExperienceInfo;
}

/**
 * Page reveal experience information
 */
export interface PageRevealExperienceInfo {

    /**
     * experience revalidation reason
     */
    readonly revalidationReason: ExperiencesRevalidationReason;

    /**
     * Staleness threshold in mins
     */
    readonly stalenessThreshold: number;

    /**
     * Provide hook into willRevalidateStaleState event.
     * This handler will execute when page reveal starts and registered experience(s) are found to be stale.
     */
    readonly willRevalidateStaleState?: (isStale: boolean) => Promise<boolean | void> | void | boolean;
}

/**
 * Defines the different reasons why the prerendered experience should be reloaded
 */
export enum ExperiencesRevalidationReason {
    Staleness = 1,
    PersistentDataUpdate = 2
}